<template>
	<div>

		<div class="blob-container">
			<div class="blob"></div>
			<div class="blob one"></div>
			<div class="blob two"></div>
			<div class="blob three"></div>
			<div class="blob four"></div>
			<div class="blob five"></div>
			<div class="blob six"></div>
			<div class="blob seven"></div>
			<div class="blob eight"></div>
			<div class="blob nine"></div>
			<div class="blob ten"></div>
			<div class="blob eleven"></div>
			<div class="blob twelve"></div>
			<div class="blob thirteen"></div>
			<div class="blob fourteen"></div>
			<div class="blob fifteen"></div>
			<div class="blob sixteen"></div>
			<div class="blob seventeen"></div>
			<div class="blob eighteen"></div>
			<div class="blob nineteen"></div>
			<div class="blob twenty"></div>
		</div>

		<div>
			<svg viewBox="0 0 1320 300">
				<text x="45%" y="50%" dy=".35em" text-anchor="middle">
					GESPYM
				</text>
			</svg>
		</div>

		<div class="right-form">
			<v-card id="mainForm" elevation="12">
				<v-card color="transparent" width="400">
					<v-card-title class="d-flex justify-center">
					<img 
						src="login-card-header.png"
						:width="$vuetify.breakpoint.mdAndUp ? '350' : '300'"
					>
					</v-card-title>
					<v-form @submit.prevent="login" class="pa-12">
						<v-text-field
							v-model="form.username"
							prepend-icon="mdi-shield-account-outline"
							label="Email"
							type="email"
							required
						/>
						<v-text-field
							v-model="form.password"
							prepend-icon="mdi-lock-outline"
							label="password"
							:append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
							:type="show1 ? 'text' : 'password'"
							name="input-10-1"
							@click:append="show1 = !show1"
					></v-text-field>
					<v-btn type="submit" depressed color="success" block @click="login">Login</v-btn>
					</v-form>
				</v-card>
			</v-card>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { usernameErrors, passwordErrors } from './errorHandlers.js';
import Snowf from 'vue-snowf';

export default {
	name: 'Login',
	data: () => ({
		// liWithImage: [70, 0, 0, 0, 0, 0, 110, 0, 0, 130, 0, 0, 130, 0],
		show1: false,
		form: {
			username: '',
			password: '',
		},
	}),
	components: {
		Snowf,
	},
	created() {
		this.tenant = /:\/\/([^\/]+)/
			.exec(window.location.href)[1]
			.split('.')[0];
	},
	validations: {
		form: {
			username: {
				required,
			},
			password: {
				required,
			},
		},
	},
	methods: {
		login() {
			this.$v.$touch();
			if (this.$v.invalid) {
				console.log('error');
			} else {
				this.$store.commit('login/isLoadingLogin', true);
				this.$store
					.dispatch('login/userLogin', {
						username: this.form.username,
						password: this.form.password,
					})
					.then(() => {
						this.$store.dispatch('teletrabajo/getAgendadosToday');

					if(this.isDistributor){	
							this.$router.push({
								path: '/teletrabajo',
							});
						} else {
							this.$router.push({
								path: '/fichaje',
							});
						}
					})
					.catch((err) => {
						console.log('Identificación fallida');
						console.log(err);
						this.$store.dispatch('util/showStatusSnackBar', {
							statusType: 'error',
							message: 'Usuario o contraseña incorrectos',
						});
					})
					.finally(() => {
						this.$store.commit('login/isLoadingLogin', false);
					});
			}
		},
	},
	computed: {
		usernameErrors,
		passwordErrors,
		// manage zoom event

		...mapState('login', {
			isLoadingLogin: (state) => state.isLoadingLogin,
		}),
		...mapGetters('login', {
			isDistributor: 'isDistributor',
		}),
	},
	beforeMount() {
		try {
			this.$store.dispatch('util/getMaintenanceStatus');
		} catch {}
	},
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@300;400;500;600;700&family=Poppins:wght@100;200;300;400;500;600;700;800&display=swap');

/* DEFAULT VALUES */

*,
*::before,
*::after {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	min-height: 100dvh;
}

#mainForm {
	background-color: #efe1ff !important;
}
/* ANIMATED BACKGROUND */
.right-form {
	display: flex;
	justify-content: right;
	margin-right: 200px;
	align-items: center;
	min-height: 100vh;
	background-color: #ffffff00;
	position: relative;
}

.container {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #fff;
	min-height: 100dvh;
	overflow: hidden;
	position: relative;
}

.blob-container {
	min-height: 100vh;
	overflow: hidden;
	position:absolute;
	width: 100%;
	filter: blur(10px);
}

.blob {
	border-radius: 50%;
	opacity: 0.8;
	position: absolute;
}

.blob.one{
	background: #ccf6c8;
	height: 200px;
	width: 200px;
	left: 10px;
	top: 10px;
	animation: movement_two 18s ease-in-out infinite both;
}

.blob.two{
	background: #e8d5fd;
	height: 200px;
	width: 200px;
	left: 1000px;
	top: 30px;
	animation: movement_two 21s ease-in-out infinite both;
}

.blob.three{
	background: #bce1f1;
	height: 160px;
	width: 160px;
	left: 500px;
	top: 60px;
	animation: movement_one 12s ease-in-out infinite both;
}

.blob.four{
	background: #cdefe7;
	height: 120px;
	width: 120px;
	left: 480px;
	top: 250px;
	animation: movement_one 16s ease-in-out infinite both;
}

.blob.five{
	background: #ffcef5;
	height: 100px;
	width: 100px;
	left: 150px;
	top: 400px;
	animation: movement_two 7s ease-in-out infinite both;
}

.blob.six{
	background: #e8d5fd;
	height: 130px;
	width: 130px;
	left: 400px;
	top: 400px;
	animation: movement_two 12s ease-in-out infinite both;
}

.blob.seven{
	background: #ffe083;
	height: 130px;
	width: 130px;
	left: 280px;
	top: 90px;
	animation: movement_two 13s ease-in-out infinite both;
}

.blob.eight{
	background: #fdffbc;
	height: 130px;
	width: 130px;
	left: 700px;
	top: 400px;
	animation: movement_two 16s ease-in-out infinite both;
}

.blob.nine{
	background: #fdcedf;
	height: 160px;
	width: 160px;
	left: 750px;
	top: 20px;
	animation: movement_two 10s ease-in-out infinite both;
}

.blob.ten{
	background: #cdefe7;
	height: 120px;
	width: 120px;
	left: 920px;
	top: 400px;
	animation: movement_one 11s ease-in-out infinite both;
}

.blob.eleven{
	background: #ffcef5;
	height: 100px;
	width: 100px;
	left: 100px;
	top: 600px;
	animation: movement_two 8s ease-in-out infinite both;
}

.blob.twelve{
	background: #e8d5fd;
	height: 130px;
	width: 130px;
	left: 300px;
	top: 600px;
	animation: movement_two 12s ease-in-out infinite both;
}

.blob.thirteen{
	background: #ffe083;
	height: 130px;
	width: 130px;
	left: 280px;
	top: 300px;
	animation: movement_two 13s ease-in-out infinite both;
}

.blob.fourteen{
	background: #fdffbc;
	height: 130px;
	width: 130px;
	left: 700px;
	top: 600px;
	animation: movement_two 16s ease-in-out infinite both;
}

.blob.fifteen{
	background: #fdcedf;
	height: 160px;
	width: 160px;
	left: 750px;
	top: 300px;
	animation: movement_two 10s ease-in-out infinite both;
}

.blob.sixteen{
	background: #ccf6c8;
	height: 200px;
	width: 200px;
	left: 10px;
	top: 700px;
	animation: movement_two 18s ease-in-out infinite both;
}

.blob.seventeen{
	background: #e8d5fd;
	height: 200px;
	width: 200px;
	left: 1000px;
	top: 730px;
	animation: movement_two 21s ease-in-out infinite both;
}


.blob.eighteen{
	background: #bce1f1;
	height: 160px;
	width: 160px;
	left: 500px;
	top: 760px;
	animation: movement_one 12s ease-in-out infinite both;
}

.blob.nineteen{
	background: #cdefe7;
	height: 120px;
	width: 120px;
	left: 480px;
	top: 950px;
	animation: movement_one 16s ease-in-out infinite both;
}

.blob.twenty{
	background: #ffcef5;
	height: 100px;
	width: 100px;
	left: 150px;
	top: 1100px;
	animation: movement_two 7s ease-in-out infinite both;
}

@keyframes movement_one
{
		0%,
	100% { transform: none; }
	 50% { transform: translate(50%, 20%) scale(1); }
}

@keyframes movement_two
{
		0%,
	500% { transform: none; }
	 50% { transform: translate(20%, 80%) scale(1.3);}
}


svg {
	font-family: Dosis !important;
	position: absolute;
	width: 100%;
	height: 100%;
	right: 15%;
}
svg text {
	text-transform: uppercase;
	animation: stroke 5s infinite alternate ease-out;
	stroke-width: 2;
	stroke: #ffc800;
	font-size: 150px;
}
@keyframes stroke {
	0% {
		fill: rgba(72, 138, 20, 0);
		stroke: rgb(212, 159, 0);
		stroke-dashoffset: 25%;
		stroke-dasharray: 0 50%;
		stroke-width: 2;
	}
	20% {
		fill: rgba(72, 138, 20, 0);
		stroke: rgb(128, 163, 0);
	}
	40% {
		fill: rgba(72, 138, 20, 0);
		stroke: rgb(172, 0, 103);
		stroke-width: 3;
	}
	100% {
		fill: rgb(0, 0, 0);
		stroke: rgb(0, 0, 0);
		stroke-dashoffset: -25%;
		stroke-dasharray: 50% 0;
		stroke-width: 0;
	}
}

/* MEDIA QUERIES */
@media (max-width: 1200px) {
	svg {
		position: relative;
		left: 5%;
		margin-bottom: -25%;
	}
}

@media (max-width: 670px) {
	svg {
		position: relative;
		left: 5%;
		margin-bottom: -25%;
	}

	svg text {
		font-size: 250px;
	}

	.right-form {
		justify-content: center;
		margin-left: 30px;
		margin-right: 30px;
	}
}

</style>